import React from 'react';
import { CheckIcon } from 'lucide-react';
import { CTAButton } from './CTAButton';
import { PriceBlock } from './PriceBlock';
import { SectionTag } from './SectionTag';
import { OFFER_INCLUDES, PRODUCT_NAME, PRODUCT_SUBTITLE } from './salesData';
import { BUNDLE_IMAGE_URL } from '../utils/headMeta';

/** Bloque de oferta: mockup grande, precio, resumen de lo incluido y CTA fuerte. */
export function OfferSection() {
  return <section id="comprar" className="w-full bg-ink py-16 text-white sm:py-20" data-id="element-126" data-mp="icggzgxyh342">
      <div className="mx-auto w-full max-w-6xl px-5 sm:px-6" data-id="element-127" data-mp="me1zpix68bm6">
        <div className="text-center" data-id="element-128" data-mp="rdwrdoort58a">
          <SectionTag tone="dark" data-id="element-129" data-mp="rey37vdm1vr2">La oferta</SectionTag>
          <h2 className="mx-auto mt-4 max-w-2xl font-display text-[1.95rem] font-extrabold leading-tight sm:text-[2.5rem]" data-id="element-130" data-mp="rc3kq9e5ql0a">
            Llevate los 100 scripts hoy
          </h2>
        </div>

        <div className="mt-10 overflow-hidden rounded-3xl border border-graphite-line bg-graphite" data-id="element-131" data-mp="2t7m9kdljwzb2">
          <div className="grid gap-8 p-6 sm:p-8 lg:grid-cols-[1fr_1fr] lg:items-center lg:gap-12 lg:p-10" data-id="element-132" data-mp="2y67aygcjhp13">
            <img src={BUNDLE_IMAGE_URL} alt={`Mockup de ${PRODUCT_NAME}: tapa, celulares con conversaciones y fichas de scripts por etapa`} width={1224} height={1280} loading="lazy" decoding="async" className="mx-auto w-full max-w-[400px] rounded-2xl border border-graphite-line lg:max-w-[440px]" data-id="element-133" data-mp="xws6a3nfw0wo" />

            <div data-id="element-134" data-mp="1gnjciwc4rb6u">
              <h3 className="font-display text-[1.5rem] font-extrabold leading-tight sm:text-[1.8rem]" data-id="element-135" data-mp="1gn1i8591371k">
                {PRODUCT_NAME}
              </h3>
              <p className="mt-2 font-sans text-[0.98rem] leading-relaxed text-white/65" data-id="element-136" data-mp="1cnsnax29534f">
                {PRODUCT_SUBTITLE}
              </p>

              <ul className="mt-6 flex flex-col gap-2.5 border-t border-white/10 pt-6" data-id="element-137" data-mp="16szadmxtag7">
                {OFFER_INCLUDES.map(item => <li key={item} className="flex items-start gap-2.5" data-id="element-138" data-mp="3sbixzxze5nz4">
                    <CheckIcon className="mt-0.5 h-4 w-4 shrink-0 text-wa" aria-hidden strokeWidth={3} data-id="element-139" data-mp="3tv154iymbb8k" />
                    <span className="font-sans text-[0.92rem] leading-snug text-white/85" data-id="element-140" data-mp="3ku3140o6j3pz">
                      {item}
                    </span>
                  </li>)}
              </ul>

              <div className="mt-7 rounded-2xl border border-graphite-line bg-ink p-5" data-id="element-141" data-mp="3b2gpi37xj2mp">
                <PriceBlock size="lg" tone="dark" data-id="element-142" data-mp="3fuhxhcy2e76x" />
                <CTAButton className="mt-5 w-full" label="COMPRAR AHORA" data-id="element-143" data-mp="3fwb44s8ogrex" />
                <p className="mt-3 text-center font-sans text-[0.75rem] text-white/50" data-id="element-144" data-mp="316wy9u4b8s4a">
                  Acceso inmediato · 100% digital
                </p>
              </div>

            </div>
          </div>
        </div>
      </div>
    </section>;
}